// extracted by mini-css-extract-plugin
export default {"SearchPagination":"SearchPagination1dFG1HpdFx63","SearchPagination-State":"SearchPagination-State3hh8KlHeFhSg","SearchPagination-Button":"SearchPagination-Button2I5a7Gx7huF7"};